import styled from '@emotion/styled';

export const LobbyContainer = styled.div`
    min-height: 100vh;
    background: #e6eeed;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    .container {
        min-height: calc(100vh - 2rem);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
    }
    .main_container {
        width: min(100%, 720px);
        padding: 5rem 0 2rem;
    }
    .controlContainer {
        margin-top: 2rem;
        padding: 2rem;
        width: 100%;
        background: #d7d7d7;
        border-radius: 12px;
    }
    .userInfoDiv {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .controlsDiv {
        display: flex;
        margin: 0;
        justify-content: center;
        gap: 1.2rem;
        flex-wrap: wrap;
    }
    .controlSwitch label {
        margin-bottom: 0;
        font-size: 2rem;
    }
    .centerContainer {
        text-align: center;
        margin-top: 1rem;
        display: flex;
        justify-content: center;
        button {
            padding: 0.5rem 2rem;
        }
    }
    .infoContainer {
        text-align: center;
        font-size: 2rem;
    }

    @media (max-width: 900px) {
        padding: 0.75rem;

        .closeButton {
            top: 1rem;
            right: 1rem;
            padding: 0.65rem 1.2rem !important;
            font-size: 16px !important;
        }
        .main_container {
            padding: 4.5rem 0 1.25rem;
        }
        .infoContainer {
            font-size: 1.1rem;
            line-height: 1.4;
            padding: 0 0.25rem;
        }
        .controlContainer {
            margin-top: 1rem;
            padding: 1.1rem;
        }
        .controlSwitch {
            width: auto;
            justify-content: center;
            gap: 0.6rem;
        }
        .controlSwitch label {
            font-size: 1.9rem;
            min-width: 78px;
            text-align: right;
        }
        .controlsDiv {
            flex-direction: column;
            align-items: center;
            gap: 0.35rem;
        }
        .centerContainer {
            font-size: 15px;
        }
    }
`;
